/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Recap
 * OpenAPI spec version: 1
 */
import { useMutation } from '@tanstack/react-query';
import type { MutationFunction, QueryClient, UseMutationOptions, UseMutationResult } from '@tanstack/react-query';

import { useApiFetch } from '../client.ts';
import type { ErrorType } from '../client.ts';
import { useMutationBehavior } from '../mutations.ts';
import type { ErrorResponse, IssueReportInput } from './schemas.ts';

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];

export const getCreateIssueReportUrl = () => {
    return `/issue-reports`;
};

/**
 * @summary Create Issue Report
 */
export const useCreateIssueReportHook = (): ((
    issueReportInput: IssueReportInput,
    options?: Parameters<ReturnType<typeof useApiFetch>>[1]
) => Promise<void>) => {
    const getHeaders = (h?: NonNullable<RequestInit['headers']>): Record<string, string | readonly string[]> => {
        if (!h) return {};
        if (h instanceof Headers) return Object.fromEntries(h.entries());
        if (Symbol.iterator in h) {
            return Object.fromEntries(
                Array.from(h as Iterable<Iterable<string>>, (entry) => Array.from(entry) as [string, string])
            );
        }
        const headers: Record<string, string | readonly string[]> = {};
        for (const [name, value] of Object.entries<string | readonly string[] | undefined>(h)) {
            if (value !== undefined) headers[name] = value;
        }
        return headers;
    };

    const customFetcher = useApiFetch();
    return (issueReportInput: IssueReportInput, options?: Parameters<ReturnType<typeof useApiFetch>>[1]) => {
        return customFetcher(getCreateIssueReportUrl(), {
            ...options,
            method: 'POST',
            headers: { 'Content-Type': 'application/json', ...getHeaders(options?.headers) },
            body: JSON.stringify(issueReportInput),
        });
    };
};

export const getCreateIssueReportMutationKey = () => ['createIssueReport'] as const;

export const useCreateIssueReportMutationOptions = <TError = ErrorType<ErrorResponse>, TContext = unknown>(options?: {
    mutation?: UseMutationOptions<
        Awaited<ReturnType<ReturnType<typeof useCreateIssueReportHook>>>,
        TError,
        CreateIssueReportMutationVariables,
        TContext
    >;
    request?: SecondParameter<ReturnType<typeof useApiFetch>>;
}): UseMutationOptions<
    Awaited<ReturnType<ReturnType<typeof useCreateIssueReportHook>>>,
    TError,
    CreateIssueReportMutationVariables,
    TContext
> => {
    const mutationKey = getCreateIssueReportMutationKey();
    const { mutation: mutationOptions, request: requestOptions } = options
        ? options.mutation && 'mutationKey' in options.mutation && options.mutation.mutationKey
            ? options
            : { ...options, mutation: { ...options.mutation, mutationKey } }
        : { mutation: { mutationKey }, request: undefined };

    const createIssueReport = useCreateIssueReportHook();

    const mutationFn: MutationFunction<
        Awaited<ReturnType<ReturnType<typeof useCreateIssueReportHook>>>,
        CreateIssueReportMutationVariables
    > = (props) => {
        const { data } = props ?? {};

        return createIssueReport(data, requestOptions);
    };

    const customOptions = useMutationBehavior(
        { ...mutationOptions, mutationFn },
        { url: `/issue-reports` },
        { operationId: 'create_issue_report', operationName: 'createIssueReport' }
    );

    return customOptions;
};

export type CreateIssueReportMutationResult = NonNullable<
    Awaited<ReturnType<ReturnType<typeof useCreateIssueReportHook>>>
>;
export type CreateIssueReportMutationBody = IssueReportInput;
export type CreateIssueReportMutationError = ErrorType<ErrorResponse>;
export type CreateIssueReportMutationVariables = { data: IssueReportInput };

/**
 * @summary Create Issue Report
 */
export const useCreateIssueReport = <TError = ErrorType<ErrorResponse>, TContext = unknown>(
    options?: {
        mutation?: UseMutationOptions<
            Awaited<ReturnType<ReturnType<typeof useCreateIssueReportHook>>>,
            TError,
            CreateIssueReportMutationVariables,
            TContext
        >;
        request?: SecondParameter<ReturnType<typeof useApiFetch>>;
    },
    queryClient?: QueryClient
): UseMutationResult<
    Awaited<ReturnType<ReturnType<typeof useCreateIssueReportHook>>>,
    TError,
    CreateIssueReportMutationVariables,
    TContext
> => {
    return useMutation(useCreateIssueReportMutationOptions(options), queryClient);
};
